import styled, { css } from 'styled-components';
import { UniversalPicker } from '@rainbow-modules/forms';
import Button from '../../components/Button';
import { BLACK, BRAND, DARK_GREY } from '../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #fff;
    min-height: 100vh;

    @media (max-width: 800px) {
        height: 100%;
        min-height: 100%;
    }
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 460px;
    width: 100%;
    padding: 1rem 2rem 2.5rem 2rem;
    gap: 24px;
    flex-grow: 1;
`;

export const StyledButton = styled(Button)`
    width: 100%;
    margin-top: 1rem;
`;

export const TopContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const Message = styled.div`
    display: flex;
    gap: 0.5rem;
    color: ${DARK_GREY};
    font-size: 0.85rem;
    font-weight: 300;
    line-height: 1.375rem;
    padding: 1rem 0;
`;

// Picker Styles

interface StyledRadioItemProps {
    isHover: boolean;
    isFocused: boolean;
    isSelected: boolean;
    disabled: boolean;
}

export const StyledUniversalPicker = styled(UniversalPicker)`
    width: 100%;

    > div {
        gap: 0.5rem;

        > div {
            margin: 0;
        }
    }
`;

export const StyledRadioItem = styled.span<StyledRadioItemProps>`
    position: relative;
    width: 100%;
    padding: 1rem;
    background-color: white;
    border: solid 1px #dbdade;
    border-radius: 0.375rem;
    display: flex;

    ${(props) => props.isHover
        && `
            background-color: #fff;    
            border: solid 1px ${BRAND};
            cursor: pointer;
    `};

    ${(props) => props.isFocused
        && `
            border: solid 1px ${BRAND};
            box-shadow: rgb(225, 33, 35) 0px 0px 2px;
    `};

    ${(props) => props.isSelected
        && `
            border: solid 1px blue
            box-shadow: rgb(225, 33, 35) 0px 0px 2px;
    `};

    ${(props) => props.disabled
        && `
            border: solid 1px blue;
            box-shadow: 0 0 0 0 transparent;
            cursor: not-allowed;
    `};
`;

export const StyledRadio = styled.span<StyledRadioItemProps>`
    position: relative;
    width: 20px;
    height: 20px;
    padding: 0;
    background: #fff;
    border: solid 2px #dbdade;
    border-radius: 20px;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;

    &::after {
        content: '';
        position: absolute;
        height: 8px;
        width: 8px;
        top: 4px;
        left: 4px;
        background: #fff;
        border-radius: 20px;
        box-sizing: border-box;
    }

    ${(props) => props.isSelected && css`
            background: ${BRAND};
            border: 2px solid;
            border-color: ${BRAND};
            box-shadow: 0px 2px 4px 0px rgba(165, 163, 174, 0.30);

            &::after {
                background: transparent;
                box-sizing: border-box;
            }
    `};

    ${(props) => props.isFocused && css`
            background: ${BRAND};
            border: 2px solid;
            border-color: ${BRAND};
            box-shadow: 0px 2px 4px 0px rgba(165, 163, 174, 0.30);
    `};

    ${(props) => props.disabled && css`
            background-color: #fff;
            border-color: #dbdade;

            &::after {
                background: #fff;
                box-sizing: border-box;
            }
    `};
`;

export const StyledPickerOptionContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-left: 0.85rem;
    padding-top: 0.15rem;
`;
export const OptionHeader = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: flex-end;
`;

export const StyledOptionLabel = styled.span`
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.3125rem;
    color: ${BLACK};
`;

export const StyledOptionDescription = styled.span`
    font-size: 0.85rem;
    font-weight: 300;
    line-height: 1.25rem;
    color: ${BLACK};
`;
